export enum RouteTypes {
    GradeBookRoute = `/gradebook`,
    ReportCardRoute = `/reportcard`,
    MttRoute = `/mandatory-targeted-tutoring`
}